import Media from 'components/shared/Media/Media';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import AccordionItem from 'components/shared/BaseAccordion/AccordionItem/AccordionItem';
import { getColorway, getYMargins } from 'utils/styles';
import { AccordionFullProps } from './types';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const AccordionFull = ({
  sys,
  sectionName,
  color,
  headline,
  margins,
  copy,
  accordionItems,
  media,
  aspectRatio,
}: AccordionFullProps) => {
  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={`${getColorway(color)} ${getYMargins(margins)}`}>
      <div className="content-wrapper">
        <div className={`flex flex-col sm:flex-row gap-12 sm:gap-16`}>
          <div className="flex flex-col gap-6 basis-1/2 empty:hidden sm:empty:block">
            {headline && (
              <div
                className="font-sans font-semibold text-heading-md md:text-heading-lg"
                {...liveUpdateAttrs(sys?.id, 'headline')}>
                <RichTextHeadline headline={headline} />
              </div>
            )}
            {copy && (
              <div className="font-serif text-body-serif" {...liveUpdateAttrs(sys?.id, 'copy')}>
                <RichTextCopy copy={copy} />
              </div>
            )}
            <div {...liveUpdateAttrs(sys?.id, 'media')} className="relative">
              {media && (
                <Media
                  className="h-full"
                  media={media}
                  sizes="(max-width: 750px) 100vw, (max-width:1440px) 50vw, 610px"
                  aspectRatio={aspectRatio}
                />
              )}
            </div>
          </div>

          <div className="basis-1/2" {...liveUpdateAttrs(sys?.id, 'content')}>
            {accordionItems.items.map((item, i) => (
              <AccordionItem
                sectionName={item.sectionName}
                sys={item.sys}
                isFirstElement={i === 0}
                accordionLabelRte={item.accordionLabelRte}
                accordionCopy={item.accordionCopy}
                key={`accordion-item-${i}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccordionFull;
